import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  Grid,
  Hidden,
  Link,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import * as styles from "../styles.scss";
import { SvgIcon } from "../../../../../../components";
import { tl } from "../../../../../../utils";

import { IFile } from "../../../types";
import FSStore from "../../../store";
import { TranscriptionBuyPopup } from "../../../../../../components/TranscriptionBuyPopup";
import api from "../../../../../../api";
import { MUIDialog } from "../../../../MUI";

interface IProps {
  data: IFile;
  onPreview?: any;
  canDelete?: boolean;
}

export const FilecardVideo = observer((props: IProps) => {
  const { fsStore } = React.useContext<{fsStore: FSStore}>(MobXProviderContext);
  const theme = useTheme();

  const [transcriptionId, setTranscriptionId] = React.useState(null);
  const [openTranscription, setOpenTranscription] = React.useState(false);
  const [transcribePopup, setTranscribePopup] = React.useState(false);
  const isTranscription = fsStore.rootStore.fsCourseStore.filterFilesType === 'transcription';
  const courseId = fsStore.course_id ? fsStore.course_id : props.data.course;

  const onPreviewImgLoad = ({ target: img }: any) => {
    if (img.offsetHeight < img.offsetWidth) {
      img.style.height = "auto";
      img.style.width = "100%";
    }
  };

  const transcribe = () => {
    api.transcriptions.getTranscriptionByFile(String(courseId), props.data.id).then((res) => {
      setTranscriptionId(res.id);
      setOpenTranscription(true);
    }).catch(() => {
      setTranscribePopup(true);
    })
  };

  return (
    <Grid item xs={6} sm={4} md={3}>
      <Card className={styles.cardsFile}>
        <CardMedia
          image={
            props.data.category === "image"
              ? props.data.icon_card || props.data.srcUrl
              : props.data.icon_card || null
          }
          className={styles.cardsPoster}
        >
          {(props.data.icon || props.data.icon_card) ? null : (
            <Box className={styles.cardsFiletypeIcon}>
              <SvgIcon type={`fs-card-${props.data.category}`} />
            </Box>
          )}

          {fsStore.canDownload || fsStore.canEdit ? (
            <Box m={0.5} className={styles.cardsControls}>
              <Grid container>
                {fsStore.canDownload ? (
                  <a
                    href={props.data.downloadUrl}
                    target="_blank"
                    title={tl("Скачать")}
                    className={styles.cardsControlsListItem}
                  >
                    <SvgIcon type="fs-card-download" />
                  </a>
                ) : null}

                {fsStore.canEdit ? (
                  <a
                    href={`/panel/files/edit?course_id=${
                      fsStore.course_id ? fsStore.course_id : props.data.course
                    }&id=${props.data.id}&category=index`}
                    title={tl("Настройки файла")}
                    target="_blank"
                    className={styles.cardsControlsListItem}
                  >
                    <SvgIcon type="fs-card-settings" />
                  </a>
                ) : null}
              </Grid>
            </Box>
          ) : null}

          {fsStore.isFilesCheckAvailable || props.canDelete ? (
            <>
              {!isTranscription && (<Box className={styles.cardsCheck}>
                <Checkbox
                  checked={fsStore.isFileChecked(props.data)}
                  onChange={() => fsStore.onFileCheck(props.data)}
                  color="primary"
                />
              </Box>)}
              {fsStore.onAttach && !isTranscription ? (
                <Hidden only="xs">
                  {!fsStore.getCheckedFilesCount ? (
                    <Box m={0.5} className={styles.cardsAttach}>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          fsStore.onAttachAll([props.data]);
                        }}
                      >
                        {tl("Прикрепить")}
                      </Button>
                    </Box>
                  ) : null}
                </Hidden>
              ) : null}
            </>
          ) : null}

          {/*TODO: индикатор готовой транскрипции <Box
            m={0.5}
            className={`${styles.cardsControls} ${styles.cardsControlsTranscription}`}
          >
            {!props.data.transcribed &&
              <TsStatusIcon titleAccess="У этого видео уже есть транскрибация. Вы можете найти ее в разделе Транскрибации" />
            }
          </Box>*/}

          <Box
            m={0.5}
            className={`${styles.cardsControls} ${styles.cardsControlsProtect}`}
          >
            {props.data.protected ? (
              <SvgIcon
                type="fs-card-protector protected"
                title={tl(
                  "Ваш файл защищен, чтобы выключить защиту зайдите в его настройки в пункт «Защита файла»."
                )}
              />
            ) : (
              <SvgIcon
                type="fs-card-protector"
                title={tl(
                  "Ваш файл не защищен, чтобы включить защиту зайдите в его настройки в пункт «Защита файла»."
                )}
              />
            )}
          </Box>

          <Box
            m="auto"
            className={`${styles.cardsControls} ${styles.cardsControlsPlay}`}
            onClick={isTranscription ? transcribe : () => props.onPreview(props.data.id, props.data.category)}
          >
            <SvgIcon type="fs-card-play" />
          </Box>
        </CardMedia>
        <CardContent className={styles.cardsInfo}>
          <Box
            m={-1}
            color={theme.palette.primary.main}
            className={styles.cardsFilename}
            title={`${props.data.name}${props.data.extension}`}
          >
            {props.data.name}
            {props.data.extension}
          </Box>
        </CardContent>

        <Box
          title={`${props.data.name}${props.data.extension}`}
          onClick={
            isTranscription
              ? transcribe
              : fsStore.getCheckedFilesCount
                  ? () => fsStore.onFileCheck(props.data)
                  : () => props.onPreview(props.data.id, props.data.category)
          }
          className={styles.cardsMask}
        />
      </Card>
      <TranscriptionBuyPopup open={transcribePopup} onClose={() => setTranscribePopup(false)} preview={props.data.icon_card} fileId={String(props.data.id)} courseId={String(fsStore.course_id ? fsStore.course_id : props.data.course)}></TranscriptionBuyPopup>
      <MUIDialog onClose={() => setOpenTranscription(false)} open={openTranscription} title="Для этого видео уже есть транскрибация">
        <Box pb={2}>
          {tl('Открыть транскрибацию?')}
        </Box>
        <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
          <Grid item>
            <Link href={`/panel/transcriptions/edit?course_id=${courseId}&transcription_id=${transcriptionId}`}>
              <Button variant="contained" color="primary">
                {tl("Открыть")}
              </Button>
            </Link>
          </Grid>
          <Grid item>
            <Button variant="outlined" onClick={() => setOpenTranscription(false)} style={{color: '#4C8EDA'}}>
              {tl("Отмена")}
            </Button>
          </Grid>
        </Grid>
      </MUIDialog>
    </Grid>
  );
});
